import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Box, Stack, Typography } from '@mui/material';

import LinearProgress from '../../DesignSystem/LinearProgress';

function QuestionOptions({ questionId, questionOptions }: any) {
  return questionOptions.map((questionOption: any, index: number) => (
    <Box key={`${questionId}-${questionOption.id}`} sx={{ mt: index === 0 ? 1 : 4 }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          mb: 1,
        }}
      >
        <Typography
          component="h4"
          sx={{
            fontWeight: '600',
            wordBreak: 'break-word',
          }}
        >
          {questionOption.label || <FormattedMessage id="POST_FORM.FORM_BUILDER.OPTIONS.OTHER" />}
        </Typography>

        <Stack direction="row" spacing={2} sx={{ alignItems: 'end' }}>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              whiteSpace: 'nowrap',
            }}
          >
            <FormattedMessage
              id="QUESTIONS.RESULTS.ANSWERS_COUNT"
              values={{ count: questionOption.count }}
            />
          </Typography>
          <Typography>
            <FormattedNumber
              value={questionOption.percentage / 100}
              style="percent"
              minimumFractionDigits={1}
            />
          </Typography>
        </Stack>
      </Stack>

      <LinearProgress value={questionOption.percentage} title={questionOption.label} />
    </Box>
  ));
}

export default QuestionOptions;
